export enum WireStatus {
    PROCESS = "P",
    HOLD = "H",
    VOID = "V",
    UNVERIFIED = "U",
}

export default WireStatus;
